export default "__VITE_ASSET__BJFmeytJ__"